<!--
 * @Description: 平台审核，代办供应商仅展示
                    园区个体平台审核中，不展示
                    客户个体审核中，展示
 * @Date: 2025-09-12 17:49:40
-->
<template>
  <BaseTextTitle class="account-info__items__title">平台审核</BaseTextTitle>
  <BaseTextContent>
    <BaseForm
      class="account-info__items"
      ref="ruleFormRef"
      disabled
      :model="formData"
      :column-count="1"
    >
      <template v-if="formData.auditStatus == 14">
        <BaseFormItem label="操作" prop="auditStatus">
          <div>{{ LICENSE_AUDIT_STATUS[formData.auditStatus]?.label }}</div>
        </BaseFormItem>
        <BaseFormItem label="原因类别" prop="auditTerminationReason">
          <div>{{ formData.auditTerminationReason }}</div>
        </BaseFormItem>
        <BaseFormItem label="备注" prop="auditTerminationRemark">
          <div>{{ formData.auditTerminationRemark }}</div>
        </BaseFormItem>
      </template>
      <template v-else>
        <BaseFormItem label="个体户类别" prop="individualType">
          <div>{{ INDIVIDUAL_TYPE[formData.individualType]?.label }}</div>
        </BaseFormItem>
        <BaseFormItem label="意见" prop="individualType">
          <div>{{ auditText }}</div>
        </BaseFormItem>
      </template>
    </BaseForm>
  </BaseTextContent>
</template>

<script lang="ts" setup>
import { computed, ref } from 'vue';
import {
  BaseFormItem,
  BaseTextContent,
  BaseTextTitle,
  BaseForm
} from 'xrk-components';
import { IndividualInfoDetailData } from '../../data-source/types';
import { LICENSE_AUDIT_STATUS, INDIVIDUAL_TYPE } from '../../constants';

const formData = defineModel<IndividualInfoDetailData>();
const ruleFormRef = ref(null);

const auditText = computed(() => {
  if (formData.value.auditStatus >= 21) return '平台通过';
  if (formData.value.auditStatus)
    return LICENSE_AUDIT_STATUS[formData.value.auditStatus].label;
  return '';
});

defineExpose({
  validate: () => {
    return ruleFormRef.value.validate();
  }
});
</script>
